<div class="disk-usage">
  <mat-card class="overview row">
    <div class="bandwidth space column">
      <div class="spinner">
        <mat-progress-spinner
          diameter="126"
          class="bandwidth-circle"
          mode="determinate"
          [value]="bandwidthPercent()"
        ></mat-progress-spinner>
        <span class="spinner-text">{{ bandwidthPercent() }}%</span>
        <div class="spinner-background"></div>
      </div>

      <div class="texts row">
        <span
          ><span class="bold">{{ currentUsage() | bytesToSize }}</span> /
          {{ bandwidthLimit() | bytesToSize }}</span
        >
        <button
          matRipple
          class="icon-button"
          matTooltip="Change Quota"
          [matTooltipShowDelay]="500"
          matTooltipPosition="above"
        >
          <fa-icon [icon]="['fas', 'pen']" size="lg"></fa-icon>
        </button>
      </div>
      <p class="hint">Updates automatically every 10 minutes</p>
    </div>

    <div class="divider"></div>

    <div class="disk-usage">
      <div class="small-cards">
        <div class="elevated card">
          <div class="row">
            <fa-icon [icon]="['fas', 'folder-open']" size="lg"></fa-icon>
            <span>Files</span>
          </div>
          <span class="bold">{{ filesUsage() | bytesToSize }}</span>
        </div>

        <div class="elevated card">
          <div class="row">
            <fa-icon [icon]="['fas', 'envelope']" size="lg"></fa-icon>
            <span>Mailboxes</span>
          </div>
          <span class="bold">{{ mailboxesUsage() | bytesToSize }}</span>
        </div>

        <div class="elevated card">
          <div class="row">
            <fa-icon [icon]="['fas', 'database']" size="lg"></fa-icon>
            <span>Databases</span>
          </div>
          <span class="bold">{{ databasesUsage() | bytesToSize }}</span>
        </div>
      </div>

      <div class="usages">
        <div class="column">
          <div class="usage row">
            <div class="label row">
              <fa-icon [icon]="['fas', 'house']" size="lg"></fa-icon>
              <span>Plan usage (db excl.)</span>
            </div>

            <mat-progress-bar mode="determinate" [value]="homeDirPercentage()"></mat-progress-bar>
            <span>
              <span class="bold">{{ usage()?.quotaSnapshot?.blockUsed | bytesToSize }} </span>
              / {{ usage()?.quotaSnapshot?.blockHard | bytesToSize }}</span
            >
          </div>
          <div class="hint">
            <span>Updates automatically every {{ updateInterval() }} minutes.</span>
          </div>
        </div>
        <div class="column">
          <div class="usage row">
            <div class="label row">
              <fa-icon [icon]="['fas', 'database']" size="lg"></fa-icon>
              <span>Total (db incl.)</span>
            </div>

            <mat-progress-bar mode="determinate" [value]="siteTotalPercentage()"></mat-progress-bar>
            <span>
              <span class="bold">{{ siteTotal() | bytesToSize }}</span>
              / {{ usage()?.quotaSnapshot?.blockHard | bytesToSize }}</span
            >
          </div>
          <div class="hint row">
            <span
              >Last updated: <b>{{ lastUpdated() }}</b>
            </span>
            @let downtime = syncDowntime();
            <button
              matRipple
              class="icon-button"
              [matTooltip]="`The disk space data can be refreshed every ${downtime ? downtime / 60 : '30'} minutes`"
              [disabled]="isDisabled()"
              (click)="syncDiskUsage()"
            >
              <fa-icon [icon]="['fas', 'arrows-rotate']" size="lg" class="btn-icon"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </mat-card>

  <div class="websites">
    <h2>Disk Usage per Website</h2>
    <app-search-field
      placeholder="Search website"
      id="record-search"
      (searchText)="onSearch($event)"
    ></app-search-field>
    <mat-card class="websites-card" [class.loading]="collectingData()">
      @if (websiteUsage().length > 0) {
        <app-table
          #table
          [columns]="websitesColumns"
          [dataSource]="websitesData()"
          [totalCount]="websiteUsage().length"
          [expandableRows]="true"
          (pageChange)="handlePageEvent($event)"
        >
          <ng-container matColumnDef="buttons">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <div class="buttons row">
                <button
                  matRipple
                  class="icon-button"
                  matTooltip="Usage details"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  (click)="table.toggle(element)"
                >
                  <fa-icon [icon]="['fas', 'chart-column']" size="lg"></fa-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <ng-template #expandedRow let-row>
            <div class="expanded-row row space">
              <div class="radio-buttons column space">
                @if (expandedTable() === 'databases') {
                  <button matButton="filled" (click)="expandedTable.set('databases')">
                    Databases
                  </button>
                  <button matButton="elevated" (click)="expandedTable.set('mailboxes')">
                    Mailboxes
                  </button>
                } @else {
                  <button matButton="elevated" (click)="expandedTable.set('databases')">
                    Databases
                  </button>
                  <button matButton="filled" (click)="expandedTable.set('mailboxes')">
                    Mailboxes
                  </button>
                }
              </div>

              <div class="expanded-table-container">
                @if (expandedTable() === 'databases') {
                  <app-table
                    [columns]="databasesColumns"
                    [dataSource]="row.databasesUsage"
                    [totalCount]="row.databasesUsage.length"
                    [showPaginator]="false"
                  >
                  </app-table>
                } @else {
                  <app-table
                    [columns]="mailboxesColumns"
                    [dataSource]="row.mailboxUsage"
                    [totalCount]="row.mailboxUsage.length"
                    [showPaginator]="false"
                  >
                  </app-table>
                }
              </div>
            </div>
          </ng-template>
        </app-table>
      } @else {
        <div class="notification column space">
          @if (collectingData()) {
            <span class="loader"></span>
            <b>Collecting the latest disk usage data. You'll be notified when complete.</b>
          } @else {
            <h2>Nothing to Display</h2>
            <p>To check disk usage per website, click the Collect Data button.</p>
            <button matButton="filled" (click)="collectData()" [disabled]="isDisabled()">
              Collect Data
            </button>
          }
        </div>
      }
    </mat-card>
  </div>
</div>
